import type { Address, Property, PropertyCharacteristics, PropertyCommodity, PropertyDocument, PropertyList, PropertyPrice } from '~/api/gen'
import { propertyNegotiationTypeEnum, propertyTransactionTypeEnum, statePropertyEnum } from '~/api/gen'
import { trackingActif } from '../lifecycle'

const id = '2'

const reference = '999/annonce-test-2'

const address: Address = {
  city: 'Thiviers',
  postalCode: '24800',
  street: 'Avenue Charles de Gaulle',
  latitude: 45.423773,
  longitude: 0.926907,
  neighborhood: {
    label: 'Quartier x',
    codePostal: '19011',
  },
}

const commodities: PropertyCommodity = [
  'TRAIN_STATION',
  'BUS',
]

const characteristics: PropertyCharacteristics = {
  habitableArea: 100,
  landArea: 200,
  livingRoomArea: 20,
  rooms: 3,
  bedrooms: 2,
  bathrooms: 1,
  toilets: 1,
  floors: 1,
}

const price: PropertyPrice = {
  price: 120000,
  negotiationFees: 500,
  negotiationFeesType: propertyNegotiationTypeEnum.BUYER,
  deedFees: 1000,
  charges: 0,
  netPrice: 120000,
  automaticPrice: true,
}

const photos: PropertyDocument[] = [
  {
    url: 'https://plus.unsplash.com/premium_photo-1689609950112-d66095626efb?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
]

export const venteMaisonList: PropertyList = {
  id,
  reference,
  miniature: photos[0],
  transactionType: propertyTransactionTypeEnum.SALE,
  propertyType: 'MAIS',
  propertySubType: 'VILLA',
  status: statePropertyEnum.ACTIVE,
  trackingStatus: trackingActif,
  price: price.price,
  negotiationFees: price.negotiationFees,
  address,
  habitableArea: characteristics.habitableArea,
  landArea: characteristics.landArea,
  rooms: characteristics.rooms,
  bedrooms: characteristics.bedrooms,
  bathrooms: characteristics.bathrooms,
}

export const venteMaisonDetail: Property = {
  id,
  reference,
  photos,
  transactionType: propertyTransactionTypeEnum.SALE,
  propertyType: 'MAIS',
  propertySubType: 'VILLA',
  propertySizeType: 'T3',
  status: statePropertyEnum.ACTIVE,
  trackingStatus: trackingActif,
  price,
  address,
  commodities,
  characteristics,
}
